import { GradingGridRow } from './types';

export const gridToStageGradeCount = (
  rows: GradingGridRow[],
): { stage: number; grade: number; count: number }[] => {
  const result: { stage: number; grade: number; count: number }[] = [];
  const stageFields = ['s4', 's5', 's6', 's7', 's8', 's9'] as const;

  for (const row of rows) {
    for (const field of stageFields) {
      const count = Number(row[field]) || 0;
      if (count > 0) {
        result.push({
          stage: parseInt(field.slice(1)),
          grade: row.grade,
          count,
        });
      }
    }
  }

  return result;
};

export const sumGradingRows = (rows: GradingGridRow[]): number => {
  const stageFields = ['s4', 's5', 's6', 's7', 's8', 's9'] as const;

  return rows.reduce(
    (total, row) =>
      total + stageFields.reduce((sum, f) => sum + (Number(row[f]) || 0), 0),
    0,
  );
};

export const defaultGradingRows: GradingGridRow[] = [
  {
    grade: 1,
    s4: null,
    s5: null,
    s6: null,
    s7: null,
    s8: null,
    s9: null,
    total: 0,
  },
  {
    grade: 2,
    s4: null,
    s5: null,
    s6: null,
    s7: null,
    s8: null,
    s9: null,
    total: 0,
  },
  {
    grade: 3,
    s4: null,
    s5: null,
    s6: null,
    s7: null,
    s8: null,
    s9: null,
    total: 0,
  },
];
